import React, { FC } from 'react';

const TestComponent: FC = () => {
  return (
    <div className="p-8 bg-yellow-100 border-2 border-yellow-400 rounded-lg">
      <h1 className="text-2xl font-bold text-yellow-800 mb-4">TEST COMPONENT IS WORKING!</h1>
      <p className="text-yellow-700">If you can see this, the routing is working correctly.</p>
      <div className="mt-4 p-4 bg-white rounded border">
        <h2 className="font-semibold">Current Time:</h2>
        <p>{new Date().toLocaleString()}</p>
      </div>
    </div>
  );
};

export default TestComponent;
